import { MaterialLayout } from 'components/layouts';
import { Typography } from '@mui/material';
import { StyledPaper, StyledLink, Paragraph } from 'components/layouts/SharedStyles';
import { Box, Grid } from '@mui/material';
import { websiteLink } from 'utils/misc';
import { config } from 'config';

export const Placeholder = () => {
  return (
    <MaterialLayout>
      <StyledPaper>
        
        <Box sx={{ my: 2, border: '1px solid', borderColor: 'divider', p: 2, backgroundColor: 'background.paper', textAlign: 'center' }}>
            <Typography variant='body1'>
              Save the date<br />
              Portland Megaband Dance<br />
              Saturday, March 13, 2027<br />
              For more info, visit <StyledLink to={websiteLink(config.links.info)}>{config.links.info}</StyledLink>.
            </Typography>
          {/* <Grid container spacing={1}>
            <Grid item xs={2}><Typography variant='body1'>Date:</Typography></Grid>
            <Grid item xs={10}><Typography variant='body1'>Saturday, March 13, 2027</Typography></Grid>
            
            <Grid item xs={2}><Typography variant='body1'>Cost:</Typography></Grid>
            <Grid item xs={10}><Typography variant='body1'>$25 suggested, sliding scale from $15 - $40 per person</Typography></Grid>
            
            <Grid item xs={2}><Typography variant='body1'>Time:</Typography></Grid>
            <Grid item xs={10}>
              <Typography variant='body1'>
                6:45 PM Newcomers teaching session<br />
                7:15 PM - 10:30 PM Dancing
              </Typography>
            </Grid>
            
            <Grid item xs={2}><Typography variant='body1'>Place:</Typography></Grid>
            <Grid item xs={10}><Typography variant='body1'>Smith Memorial Student Union Ballroom, Portland State University, 1825 SW Broadway, Portland, OR 97201</Typography></Grid>
            
            <Grid item xs={2}><Typography variant='body1'>Caller:</Typography></Grid>
            <Grid item xs={10}><Typography variant='body1'>Lindsey Dono</Typography></Grid>
            
            <Grid item xs={2}><Typography variant='body1'>Music:</Typography></Grid>
            <Grid item xs={10}><Typography variant='body1'>The Portland Megaband - 75 musicians playing precision and enthusiasm</Typography></Grid>
          </Grid> */}
        </Box>

        {/* Join us at <StyledLink to={websiteLink(config.links.info)}>{config.event.title}</StyledLink>!<br />
        <Paragraph>The dance takes place {config.event.date} at Smith Memorial Ballroom in Portland, Oregon.</Paragraph> */}
        {/* <Typography variant="h6" sx={{ fontStyle: 'italic' }}>
          Online sales have closed, but you can pay at the door.<br />Hope to see you there!
        </Typography> */}
      </StyledPaper>
    </MaterialLayout>
  );
};
